import type { ContentProps } from '../../../split-layout/slots.js';
import type { DetailsProps } from '../../details-region/slots.js';
import type { SidebarProps } from '../../sidebar-region/slots.js';

/**
 * Defaults each slot component applies to its own props. Checked against the
 * props they default, so a default can never drift from the type of the prop
 * it seeds.
 */
export const sidebarDefaults = {
  defaultWidth: '15%',
  minWidth: 200,
  maxWidth: '50%',
  resizable: true,
  defaultCollapsed: false,
  breakpoint: 960,
} satisfies Partial<SidebarProps>;

// The content pane reserves half the details region. In split this caps the
// details panel at ~50% (its old `maxWidth` default, expressed at the content
// layer); in overlay the panel floats, so the reserve does not constrain it.
export const contentDefaults = {
  minWidth: '50%',
} satisfies Partial<ContentProps>;

export const detailsDefaults = {
  minWidth: 320,
  defaultWidth: '25%',
  resizable: true,
  defaultCollapsed: false,
  defaultLayout: 'split',
  breakpoint: 600,
} satisfies Partial<DetailsProps>;
